// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{
    display:flex;
  }
  .custom-header{
    height:36px;
    display:flex;
    align-items: center;
    flex:1 1 auto;
    line-height:27px;
    overflow:hidden;
    z-index: 1;
  }

  .ag-group-expanded,.ag-group-contracted{
    display: inline-block;
    margin-left:11px;
  }
  .header-title{
    overflow:hidden;
    display:flex;
  }
  .group-name{
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 0;
  }
  .action-buttons-container{
    flex-grow: 1;
    display:flex;
    gap:10px;
    justify-content: flex-end;
  }

  .action-buttons{
    display:flex;
    align-items: center;
    justify-content: center;
    width:176px;
    margin-right:12px;
  }

  .icon{
    font-size:20px;
    cursor:pointer;
    color:#526B7A;
  }

  .action-buttons .btn-small{
    padding: 0px 10px;
    font-size: 12px;
    height: 24px;
    box-shadow: 0px 1px 0px 0px #dae2e8;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
